import { CustomValidator } from '../hooks/useFieldValidation';

import validation from './validation';

export const emailValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'email') {
    if (!validation.email.isValid(value)) {
      setInvalidField('email');
      return;
    }
    removeInvalidField('email');
  }
};

export const firstNameValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'firstName') {
    if (!validation.firstName.isValid(value)) {
      setInvalidField('firstName');
      return;
    }
    removeInvalidField('firstName');
  }
};

export const lastNameValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'lastName') {
    if (!validation.lastName.isValid(value)) {
      setInvalidField('lastName');
      return;
    }
    removeInvalidField('lastName');
  }
};

export const isValidPhoneNumber = (value: string) => {
  return validation.phoneNumber.isValid(value);
};

export const phoneNumberValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'phoneNumber') {
    if (!isValidPhoneNumber(value)) {
      setInvalidField('phoneNumber');
      return;
    }
    removeInvalidField('phoneNumber');
  }
};

export const isValidAge = (value: string) => {
  return validation.age.isValid(value);
};

export const isValidZip = (country: string, value?: string) => {
  return validation.zip.isValid(country, value);
};

export const birthdayValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'birthday') {
    if (value && !isValidAge(value)) {
      setInvalidField('birthday');
      return;
    }
    removeInvalidField('birthday');
  }
};

export const passwordValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'password') {
    if (!value) {
      setInvalidField('password');
      return;
    }
    removeInvalidField('password');
  }
};

export const addressValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'address') {
    if (!value) {
      setInvalidField('address');
      return;
    }
    removeInvalidField('address');
  }
};

export const cityValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'city') {
    if (!value) {
      setInvalidField('city');
      return;
    }
    removeInvalidField('city');
  }
};

export const customStateValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'customState') {
    if (!value) {
      setInvalidField('customState');
      return;
    }
    removeInvalidField('customState');
  }
};

export const stateValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'state') {
    if (!value) {
      setInvalidField('state');
      return;
    }
    removeInvalidField('state');
  }
};

export const mlifeNumberValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'mlifeNumber') {
    if (value && !validation.mlifeNumber.isValid(value)) {
      setInvalidField('mlifeNumber');
      return;
    }
    removeInvalidField('mlifeNumber');
  }
};

export const activationCodeValidator: CustomValidator = (field, value, setInvalidField, removeInvalidField) => {
  if (field === 'activationCode') {
    if (!value || !validation.activationCode.isValid(value)) {
      setInvalidField('activationCode');
      return;
    }
    removeInvalidField('activationCode');
  }
};
